import { BaseService } from "./common/base";

export class PaymentService extends BaseService<unknown> {
  constructor() {
    super("payment");
  }

  getBalance() {
    return this._get("balance");
  }

  getTransactions(limit: number = 10) {
    return this._get(`transactions?limit=${limit}`);
  }

  getStripeToken() {
    return this._get("stripe-token");
  }

  getStripeConfig(): Promise<{ publishableKey: string }> {
    return this._get("stripe-config");
  }

  refreshPaymentIntent(id: string) {
    return this._post(`${id}/refresh`);
  }

  getLoginLink() {
    return this._get("login-link");
  }
}
